import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeneralError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 417,
	height: 279,
	viewBox: "0 0 417 279",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 154.337C-5.57363e-05 179.434 21.0303 239.37 66.5215 265.733C112.971 292.651 151.915 270.128 206.692 271.016C248.065 271.687 273.561 283.593 312.651 271.016C367.961 253.221 427.97 222.712 415.284 169.747C406.462 132.914 364.448 133.512 338.309 104.583C312.234 75.7245 315.03 45.9308 282.716 23.1272C212.768 -26.2346 127.459 10.751 62.2451 65.3961C29.1087 93.1621 5.57365e-05 129.239 0 154.337Z",
			fill: "#FFF2F5"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 219,
			cy: 72,
			r: 47,
			stroke: "#F29FB2",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 78,
			cy: 76,
			rx: 78,
			ry: 76,
			transform: "matrix(-1 0 0 1 194 98)",
			stroke: "#F29FB2",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 325.5,
			cy: 185,
			rx: 31.5,
			ry: 32,
			stroke: "#F2A2B5",
			strokeWidth: 1.30603,
			strokeLinecap: "round",
			strokeDasharray: "5.22 7.84"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 126.311,
			y: 58.188,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 126.311 58.188)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 303.897,
			y: 107.875,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 303.897 107.875)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 103.252,
			y: 218.341,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 103.252 218.341)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 372.907,
			y: 215.531,
			width: 14.272,
			height: 2.83584,
			transform: "rotate(-45 372.907 215.531)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 128.205,
			y: 47.8472,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 128.205 47.8472)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 305.792,
			y: 97.5342,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 305.792 97.5342)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 105.146,
			y: 208,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 105.146 208)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 374.802,
			y: 205.19,
			width: 14.7595,
			height: 3.03557,
			transform: "rotate(45 374.802 205.19)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.2705 68.0039C88.7341 68.1677 93.9238 73.4588 93.9238 79.9619L93.9199 80.2705C93.7561 86.734 88.4649 91.9237 81.9619 91.9238L81.6533 91.9199C75.2924 91.7587 70.1651 86.6315 70.0039 80.2705L70 79.9619C70 73.3557 75.3558 68.0002 81.9619 68L82.2705 68.0039ZM77.6953 86.6816C78.9289 87.4666 80.3916 87.9238 81.9619 87.9238C86.3589 87.9237 89.9237 84.3589 89.9238 79.9619C89.9238 78.3917 89.4674 76.9288 88.6826 75.6953L77.6953 86.6816ZM81.9619 72C77.5649 72.0002 74 75.5649 74 79.9619C74.0001 81.6082 74.5004 83.1377 75.3564 84.4072L86.4082 73.3555C85.1386 72.4994 83.6083 72 81.9619 72Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M231.271 229.004C237.734 229.168 242.924 234.459 242.924 240.962L242.92 241.271C242.756 247.734 237.465 252.924 230.962 252.924L230.653 252.92C224.293 252.759 219.165 247.631 219.004 241.271L219 240.962C219 234.356 224.356 229 230.962 229L231.271 229.004ZM226.695 247.682C227.929 248.467 229.392 248.924 230.962 248.924C235.359 248.924 238.924 245.359 238.924 240.962C238.924 239.391 238.468 237.928 237.683 236.694L226.695 247.682ZM230.962 233C226.565 233 223 236.565 223 240.962C223 242.608 223.5 244.138 224.356 245.407L235.408 234.355C234.139 233.499 232.608 233 230.962 233Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.344 59.2631C274.171 58.627 274.65 58 275.309 58H284.691C285.35 58 285.829 58.627 285.656 59.2631L280.965 76.4625C280.697 77.445 279.303 77.445 279.035 76.4625L274.344 59.2631Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 280,
			cy: 83,
			r: 3,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dd_5649_524)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 119,
				y: 79,
				width: 176,
				height: 130,
				rx: 4,
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 118,
				y: 78,
				width: 178,
				height: 132,
				rx: 5,
				stroke: "#F39BB1",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(1 0 0 -1 127 91)",
			fill: "#EF476F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(1 0 0 -1 133 91)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			transform: "matrix(1 0 0 -1 139 91)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 152.5,
			y1: 89,
			x2: 261.5,
			y2: 89,
			stroke: "#F39DB2",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 169.5,
			y1: 193.5,
			x2: 244.5,
			y2: 193.5,
			stroke: "#FFCAD7",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 186.5,
			y1: 199.5,
			x2: 226.5,
			y2: 199.5,
			stroke: "#FFCAD7",
			strokeWidth: 3,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M216.879 112.04L217.214 112.599L245.699 163.491C246.553 165.017 247 166.719 247 168.447C247 174.067 242.378 178.661 236.55 178.982L235.897 179H178.105C176.241 179 174.408 178.554 172.774 177.704C167.594 175.009 165.572 168.963 168.059 163.954L168.366 163.381L197.673 112.488C198.713 110.682 200.286 109.205 202.198 108.238C207.411 105.603 213.838 107.315 216.879 112.04ZM207.5 157.528C205.456 157.528 203.799 159.103 203.799 161.045C203.799 162.988 205.456 164.563 207.5 164.563C209.544 164.563 211.201 162.988 211.201 161.045C211.201 159.103 209.544 157.528 207.5 157.528ZM207.5 129.388C205.602 129.388 204.038 130.576 203.824 132.106L203.799 132.465V150.933L203.824 151.291C204.038 152.822 205.602 154.01 207.5 154.01C209.398 154.01 210.962 152.822 211.176 151.291L211.201 150.933V132.465L211.176 132.106C210.962 130.576 209.398 129.388 207.5 129.388Z",
			fill: "#EF476F"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_dd_5649_524",
			x: 89,
			y: 73,
			width: 236,
			height: 190,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feMorphology", {
					radius: 4,
					operator: "dilate",
					in: "SourceAlpha",
					result: "effect1_dropShadow_5649_524"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 24 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.05 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_5649_524"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 8 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "effect1_dropShadow_5649_524",
					result: "effect2_dropShadow_5649_524"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect2_dropShadow_5649_524",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgGeneralError);
export { ForwardRef as ReactComponent };
